import { render, staticRenderFns } from "./pointRoute.vue?vue&type=template&id=71a3f34c&scoped=true"
import script from "./pointRoute.vue?vue&type=script&lang=js"
export * from "./pointRoute.vue?vue&type=script&lang=js"
import style0 from "./pointRoute.vue?vue&type=style&index=0&id=71a3f34c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a3f34c",
  null
  
)

export default component.exports